export default function buildCircleConfig(data, name, unit) {
  return {
    tooltip: {
      trigger: 'item'
    },
    color: ['#FAAA00', '#4DCBCB', '#F3667C', '#1990FF', '#6300BF', '#7B4D12', '#F2919E', '#828116'],
    legend: {
      bottom: 10
    },
    series: [
      {
        name: name,
        type: 'pie',
        radius: '65%',
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        data: data,
        label: {
          normal: {
            position: 'outer',
            formatter: '{b} : {c}' + unit
          }
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_common_circle.js